import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../notFound.css";

const NotFound = () => {
  return (
    <>
      <Navbar />

      <div className="not-found">
        <h1 className="not-found__code">404</h1>
        <p className="not-found__text">
          No encontramos la página que estás buscando.
        </p>
        <p className="not-found__subtext">
          Puede que el producto ya no esté disponible o que el link tenga un
          error.
        </p>

        <div className="not-found__actions">
          <Link to="/" className="not-found__btn">
            Volver al inicio
          </Link>
          <a
            href="https://wa.me/5491128181122?text=%C2%A1Hola!%20Estaba%20buscando%20un%20producto%20en%20la%20web%20y%20no%20lo%20encontr%C3%A9."
            target="_blank"
            rel="noreferrer"
            className="not-found__btn not-found__btn--ghost"
          >
            Escribir por WhatsApp
          </a>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default NotFound;
